declare function setApiUrlsForEnrollment(a: any): any;
declare function getChatbotIdForEnrollmentBot(): any;
declare function setApiUrlsForStudentStaff(a: any): any;
declare function getChatbotIdForStudentAzureBot(): any;
import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AssetsPath } from 'src/static-assets/assets-path';
import { ToastrBridgeService, ToastType } from './services/toastr-bridge.service';
import { ToastEventDetail } from './app.component.interface';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styles: []
})
export class AppComponent implements OnInit, OnDestroy{
    public assetsPath = AssetsPath;
    private isAuthenticated:boolean = false;
    user: string = '';
  public title = `Chat bots for ${environment.name} University`;
  public userData = {
    name: 'no user',
    email: 'no user'
  };
  public userEmail: any;
  chatbotId = "";
  acknowledgmentVerified: string = '';
  public enrollmentRouteName: string = environment.enrollmentRouteName;
  public studentAzureRouteName: string = environment.studentAzureRouteName;
  public studentbotRouteName: string = environment.studentbotRouteName;
  private routerSubscription: Subscription | null = null;

  constructor(
    public authStateService: OktaAuthStateService, 
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastrBridge: ToastrBridgeService,
    private ngZone: NgZone,
     @Inject(OKTA_AUTH) 
      private oktaAuth: OktaAuth
    ) {}
      

 async ngOnInit() {

    document.addEventListener( 'show-app-toast', this.boundHandleToastEvent);

    this.chatbotId = sessionStorage.getItem('chatbotIdEnr');
    setApiUrlsForEnrollment(environment.enrollmentConfig);
    this.acknowledgmentVerified = sessionStorage.getItem('acknowledgementVerified');
    setApiUrlsForStudentStaff(environment.studentAsStaffConfig);
    
    this.routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const currentRoute = event.urlAfterRedirects; 

        if (currentRoute.includes(this.enrollmentRouteName)) {
          // getChatbotIdForEnrollmentBot();
        } else if (currentRoute.includes(this.studentbotRouteName) || currentRoute.includes(this.studentAzureRouteName)) {
          // getChatbotIdForStudentAzureBot();
        }
      }
    });
  
}

  ngOnDestroy(): void {
        document.removeEventListener(
            'show-app-toast',
            this.boundHandleToastEvent
        );
    }

private handleToastEvent(event: Event): void {

        const detail = (event as CustomEvent<unknown>).detail;

        // Validate event structure
        if (!this.isValidToastEvent(detail)) {
            console.warn(
                '[Toastr] Ignoring invalid show-app-toast event.'
            );
            return;
        }

        // Execute inside Angular zone
        this.ngZone.run(() => {
            this.toastrBridge.show(detail.type, detail.message);
        });
    }

    // Bind once and reuse the same reference
    private readonly boundHandleToastEvent =
        this.handleToastEvent.bind(this);

    private isValidToastEvent(
        detail: unknown
    ): detail is ToastEventDetail {

        if (!detail || typeof detail !== 'object') {
            return false;
        }

        const payload = detail as Record<string, unknown>;

        return (
            (payload['type'] === 'success' ||
                payload['type'] === 'error') &&
            typeof payload['message'] === 'string' &&
            payload['message'].trim().length > 0
        );
    }


}